/**
 * .datatables
 * Bind DataTable
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

$(function()
{
    "use strict";

    /**
     * Define the selector
     *
     * @type {String}
     */
    var selector = '.datatable';

    /**
     * Define the dataAttributes shorthand
     *
     * @type {Object}
     */
    var dataAttributes = {
        placeholder   : 'af-placeholder',
        filterValue   : 'af-filter',
        sortValue     : 'af-order',
    };

    /**
     * Define method
     *
     * @param  {string) selector
     * @return {void}
     */
    $(selector).DataTable({
        initComplete: function () {
            // Iterate through each column
            // If we do not have a placeholder, we will have no need to create an autofilter
            this.api().columns().every(function () {
                /**
                 * Define the column
                 *
                 * @type DataTable.Column
                 */
                var column = this;

                /**
                 * Get the placeholder from dropdown-placeholder
                 *
                 * @type DataTable.Column
                 */
                var placeholder = $(column.header()).data(dataAttributes.placeholder)

                /**
                 * Placeholder defines the presence of the dropdown
                 *
                 * @param  {string} placeholder
                 * @return {void}
                 */
                if (placeholder) {

                    /**
                     * Create:
                     *   - a select element
                     *   - a placeholder element (selectable and enabled, null as value)
                     *   - attach to footer
                     *   - register onChange listener
                     */
                    var select = $('<select>').addClass('form-control input-sm')
                        .append($('<option>').val(null).text(placeholder))
                        .appendTo($(column.footer()))
                        .on('change', function(){
                            // Get the selected value, escaped
                            var val = $.fn.dataTable.util.escapeRegex(
                                $(this).val()
                            );
                            // Finalize
                            //   - the search against the value an
                            //   - redraw the table
                            column
                                .search( val ? '^'+val+'$' : '', true, false )
                                .draw();
                        });
                    // Map nodes instead of theri values to return filter value
                    var filters = column.nodes().map(function(cell){
                        // Add data=dropdown-filter-value to TD cell to allow filtering
                        return {
                            value : $(cell).data(dataAttributes.filterValue) || $(cell).text(),
                            order : $(cell).data(dataAttributes.sortValue) ||
                                    $(cell).data(dataAttributes.filterValue) ||
                                    $(cell).text(),
                        }
                    })
                    /**
                     * Now, chain the mapped nodes
                     *  - filter the ones that actually have a value...
                     *    We may want to reconsider if we want to see if those are separtely
                     *  - scope unique values
                     *  - sortBy data attribute order
                     *  - add a new select
                     *
                     * @param  {[type]} filter
                     * @return {[type]}
                     */
                    _.chain(filters).filter('value').uniqBy('value').sortBy(['order']).each(function(filter){
                        $('<option>').val(filter.value).text(filter.value).appendTo(select)
                    }).value()

                }
            })
        }
    });

    // register future Datatables from the remote
    $('#remote').on('loaded.bs.modal', function (e) {
        var modal  = $(this);

        modal.find(selector).DataTable();
    });
});
